// utils/solutionStorage.js

// Save parsed solution
export const saveSolutionToLocal = (questionId, solution) => {
  let solved = JSON.parse(localStorage.getItem("solvedSolutions")) || {};
  solved[questionId] = solution;
  localStorage.setItem("solvedSolutions", JSON.stringify(solved));
};

// Retrieve parsed solution
export const getSolutionFromLocal = (questionId) => {
  const solved = JSON.parse(localStorage.getItem("solvedSolutions")) || {};
  return solved[questionId] || null;
};

// Clear solutions when logout / token expire
export const clearSolutionsOnLogout = () => {
  localStorage.removeItem("solvedSolutions");
};
